import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'

export const hasSpeedFormationDueDate = country => Boolean(modulesConfig[country]?.home?.speedFormationDueDate)
